/**
 * Modèle SolidObject - Identique à Flutter
 */

export interface SolidObject {
  id: string;
  name: string;
  description?: string;
  image?: string;
  [key: string]: any;
}

export const SolidObjectFromJson = (json: any): SolidObject | null => {
  // Si pas d'objet, retourner null
  if (!json) {
    return null;
  }

  // Si pas de name, l'objet est invalide
  if (!json.name || typeof json.name !== 'string') {
    console.warn('[SolidObjectFromJson] Invalid SolidObject JSON: missing name', json);
    return null;
  }

  // Générer un id à partir du name si l'id n'est pas présent
  // Utiliser le name normalisé (lowercase, espaces remplacés par des underscores)
  const id = json.id && typeof json.id === 'string' 
    ? json.id 
    : json.name.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');

  return {
    id,
    name: json.name,
    description: json.description || '',
    image: json.image,
    ...json, // Conserver tous les autres champs
  };
};
